package navigation.settings.imagegallery.imageInfos.components

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.ColumnScope
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import com.essntl.features.file.ui.imageinfos.ImageInfosEvent
import com.essntl.features.file.ui.imageinfos.ImageInfosState
import com.essntl.uikit.components.button.primary.EsMediumPrimaryButton
import com.essntl.uikit.components.input.EsInput
import com.essntl.uikit.components.utils.EsConstants
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography
import core.dateformat.ui.formatDate

@Composable
fun ColumnScope.KeywordsImage(
    state: ImageInfosState,
    onEvent: (ImageInfosEvent) -> Unit,
) {
    var searchText by remember {
        mutableStateOf(
            state.getFile.data?.keywords
                .orEmpty()
                .joinToString(","),
        )
    }

    Text(
        text = "image created: ${state.getFile.data?.createdAt.orEmpty().formatDate(".")}",
        color = MaterialTheme.esColorScheme.textPrimary,
        style = MaterialTheme.esTypography.s2SemiBold16,
        modifier = Modifier.padding(horizontal = EsConstants.SectionHorizontalPadding),
    )

    Spacer(Modifier.height(1.spacing))

    Row(
        horizontalArrangement = Arrangement.Center,
        verticalAlignment = Alignment.CenterVertically,
        modifier = Modifier
            .fillMaxWidth()
            .clip(RoundedCornerShape(EsConstants.SectionBorderRadius))
            .padding(horizontal = EsConstants.SectionHorizontalPadding),
    ) {
        EsInput(
            value = searchText,
            onValueChange = {
                searchText = it
            },
            placeholder = "Enter keywords",
            label = "Keywords",
            modifier = Modifier.weight(3f),
        )

        Spacer(Modifier.width(1.spacing))

        EsMediumPrimaryButton(
            onClick = {
                onEvent(
                    ImageInfosEvent.UpdateImage(
                        keywords = searchText,
                    ),
                )
            },
            text = "Update",
            enabled = searchText.isNotEmpty() &&
                searchText != state.getFile.data?.keywords
                .orEmpty()
                .joinToString(","),
            loading = state.updateImage.isLoading,
            modifier = Modifier
                .padding(top = 3.spacing)
                .weight(1f),
        )
    }
}